<div
  *ngIf="visible"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="'reload-prompt-title'"
  class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/40"
>
  <div
    class="bg-white rounded-2xl w-[90vw] max-w-[450px] max-h-[90vh] overflow-y-auto p-[28px] xlplus:p-[28px] shadow-xl"
  >
    <div class="flex items-center gap-3">
      <h3
        id="reload-prompt-title"
        class="font-inter font-semibold text-[22px] xlplus:text-2xl"
      >
        {{ title }}
      </h3>
    </div>

    <div
      class="font-lato font-normal text-taxpod-gray text-[15px] xlplus:text-base mt-[16px]"
    >
      <p>{{ message }}</p>
    </div>

    <div class="flex gap-4 justify-end mt-[24px]" *ngIf="mode === 'reload'">
      <p-button
        label="Dismiss"
        (onClick)="onDismissClick()"
        variant="outlined"
        styleClass="!w-[100px] xlplus:!w-[100px] !border-taxpod-blue !text-taxpod-blue !border-[1.5px] !text-sm xlplus:!text-base hover:!bg-[#E0F2FE]"
      />
      <p-button
        label="Reload"
        (onClick)="onReloadClick()"
        styleClass="!w-[100px] xlplus:!w-[100px] !bg-taxpod-blue !border-taxpod-blue !border-[1.5px] !text-sm xlplus:!text-base !font-lato !font-bold"
      />
    </div>

    <div class="flex gap-4 justify-end mt-[24px]" *ngIf="mode === 'return-or-stay'">
      <p-button
        label="Stay"
        (onClick)="onDismissClick()"
        variant="outlined"
        styleClass="!min-w-[100px] xlplus:!min-w-[100px] !border-taxpod-blue !text-taxpod-blue !border-[1.5px] !text-sm xlplus:!text-base hover:!bg-[#E0F2FE]"
      />
      <p-button
        label="Return to files list"
        (onClick)="onReturnToFilesClick()"
        styleClass="!min-w-[160px] xlplus:!min-w-[180px] !bg-taxpod-blue !border-taxpod-blue !border-[1.5px] !text-sm xlplus:!text-base !font-lato !font-bold"
      />
    </div>
  </div>
</div>
